import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import RatingComponent from '../rating';

export const Rating = styled(RatingComponent)`
  position: absolute;
  top: ${layout.measurements.spacing100};
  left: ${layout.measurements.spacing100};
`;
